import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    colaboratorToEdit: null,
    currentAbsence: null,
  },
  mutations: {
    SET_COLABORATOR_TO_EDIT(state, payload) {
      state.colaboratorToEdit = payload
    },
    RESET_COLABORATOR_TO_EDIT(state) {
      state.colaboratorToEdit = null
    },
    SET_CURRENT_ABSENCE(state, payload) {
      state.currentAbsence = payload
    },
    RESET_CURRENT_ABSENCE(state) {
      state.currentAbsence = null
    },
  },
  actions: {
    INSERT_COLABORATOR_TO_EDIT({ commit }, payload) {
      commit('SET_COLABORATOR_TO_EDIT', payload)
    },
    INSERT_CURRENT_ABSENCE({ commit }, payload) {
      commit('SET_CURRENT_ABSENCE', payload)
    },
  },
  modules: {},
  getters: {
    $colaboratorToEdit(state) {
      return state.colaboratorToEdit
    },
    $currentAbsence(state) {
      return state.currentAbsence
    },
  },
})
